import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import CustomPaginationActionsTable from '../PaginationTable';

import {
  Container
} from "./styles";

export default function CommentComponent(props) {
  const comments = props.comments

  const [name, setName] = React.useState("");
  const [content, setContent] = React.useState("");

  const handleSubmit = (e) => {
    if (!name)
      alert("이름을 입력하세요.");
    else if (!content)
      alert("메세지를 입력하세요");
    else {
      addTweet();
    }
  };

  const addTweet = () => {
    const comment = {
      username: name,
      text: content,
    };
    fetch(process.env.REACT_APP_DB_HOST + 'addComment', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(comment),
    });
    props.setEdited(true)
    setName("")
    setContent("")
  };

  return (
    <Container>
      {/* <Box
      component="form"
      sx={{
        '& .MuiTextField-root': { m: 1},
      }}
      noValidate
      autoComplete="off"
    >
      <div className="TextField-without-border-radius">
        <TextField
          id="name"
          label="이름"
          value={name}
          style = {{m: 1, width: '40%'}}
          onChange={(event)=>{setName(event.target.value)}}
        />
        <TextField
          id="reply-multiline"
          label="댓글 달기..."
          placeholder="Placeholder"
          value={content}
          onChange={(event)=>{setContent(event.target.value)}}
          style = {{m: 1, width: '100%'}}
          InputProps={{
            endAdornment:
              <InputAdornment position="end">
                <IconButton sx={{ p: '10px' }} aria-label="menu">
                  <ArrowCircleUpIcon color="action" onClick={handleSubmit}/>
                </IconButton>
              </InputAdornment>
          }}
        />
      </div>
    </Box> */}
      <CustomPaginationActionsTable rows={comments} />
    </Container>
  );
}
